import DialogContent from '@mui/material/DialogContent'
import { DataEditContextTextField } from 'Components/reusable/DataContext/fields/DataEditContextTextField'
import { DataEditContextTranslationImport } from 'Components/reusable/DataContext/TranslationImport'
import React from 'react'
import Grid from '@mui/material/Grid2'
import { IReference } from 'types/cvsInterfaces'
import newWithEditModal from 'Components/reusable/HOC/newWithEditModal'

const ReferenceModal: React.FC<Record<string, unknown>> = () => {
  return (
    <DialogContent>
      <Grid container spacing={2}>
        <Grid>
          <DataEditContextTranslationImport<IReference> />
          <Grid container spacing={2}>
            <Grid size={6}>
              <DataEditContextTextField<IReference> field="firstName" required fullWidth insetLabel />
            </Grid>
            <Grid size={6}>
              <DataEditContextTextField<IReference> field="lastName" required fullWidth insetLabel />
            </Grid>
          </Grid>
          <DataEditContextTextField<IReference> field="company" required fullWidth insetLabel />
          <DataEditContextTextField<IReference>
            field="letter"
            maxHintLength={1500}
            required
            multiline
            grow
            rows={12}
            fullWidth
            insetLabel
          />
        </Grid>
      </Grid>
    </DialogContent>
  )
}

export default newWithEditModal(ReferenceModal)
